import axios from "@/util/axios";

const PREFIX_URI = "/luqiao/attendance/config";

export default {
    /** 查询列表 */
    list: (data) => axios.get({url: `${PREFIX_URI}/list`, data: data}),

    /** 查询全部 */
    listAll: () => axios.get({url: `${PREFIX_URI}/listAll`}),

    /** 保存 */
    saveSubmit: (data) => axios.post({url: `${PREFIX_URI}/saveSubmit`, data: data}),

    /** 删除 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id}}),

    /** 根据配置id查询工地 */
    queryClassmateListByConfigId: (configId) => axios.get({url: `${PREFIX_URI}/queryClassmateListByConfigId`, data: {configId}}),

    /** 批量设置工地的配置id */
    setSiteAttendanceConfig: (siteIds, configId) => axios.post({url: `${PREFIX_URI}/setSiteAttendanceConfig?configId=${configId}`, data: siteIds}),
    /** 项目工地施工班组整理成树结构*/
    queryProjectClassmateTree: () => axios.get({url: `${PREFIX_URI}/queryProjectClassmateTree`}),
    /** 一次性保存考勤配置的所有关联项目、工地、班组 */
    saveConfigProjectClass: (data) => axios.post({url: `${PREFIX_URI}/saveConfigProjectClass`, data}),

}